import { createRouter } from '@tanstack/react-router'
import { routeTree } from './routeTree.gen'
import { queryClient } from './lib/queryClient'

// Create router instance
export const router = createRouter({
  routeTree,
  defaultPreload: false,
  context: {
    queryClient,
  },
  // Built-in scroll restoration with instant behavior
  scrollRestoration: true,
  scrollRestorationBehavior: 'instant',
  defaultOnCatch: (error) => {
    console.error('Router error:', error)
  },
})

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}